/**
 * @generated SignedSource<<a9d7a66f3793800e93e4ae31a18cf829>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectEmailForm_forwardMessage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EmailForm_forwardMessage">;
  readonly " $fragmentType": "ConnectEmailForm_forwardMessage";
};
export type ConnectEmailForm_forwardMessage$key = {
  readonly " $data"?: ConnectEmailForm_forwardMessage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectEmailForm_forwardMessage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectEmailForm_forwardMessage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EmailForm_forwardMessage"
    }
  ],
  "type": "EmailMessage",
  "abstractKey": null
};

(node as any).hash = "91838f82a95cba4352bccb2c7af91a9d";

export default node;
